import {
  borderRadius,
  fontSize,
  fontWeight,
  maxWidth,
  width,
} from "@mui/system";

import { fonts, gutterX, radius } from "../shared/ticketLayout";

const styles = (theme) => ({
  // --- Cartão de OS: mesmo padrão do ordemServiceComponent ---
  cardHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 1,
    px: { xs: 1.5, sm: 2 },
    py: 1.25,
    minWidth: 0,
  },
  cardHeaderIdentificacao: {
    display: "flex",
    alignItems: "center",
    gap: 0.75,
    flexWrap: "wrap",
    minWidth: 0,
  },
  cardNumeroOs: {
    fontSize: fonts.sectionTitle,
    fontWeight: 700,
    letterSpacing: "-0.01em",
  },
  cardMenuButton: {
    flexShrink: 0,
  },
  cardSecao: {
    px: { xs: 1.5, sm: 2 },
    py: 1.5,
  },
  cardSecaoHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 1,
    mb: 0.5,
  },
  cardSecaoTitulo: {
    fontSize: fonts.chip,
    fontWeight: 600,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    color: theme.palette.text.secondary,
  },
  textoVazio: {
    fontSize: fonts.body,
    fontStyle: "italic",
    color: theme.palette.text.disabled,
    p: 1,
  },
  boxChipCampo: {
    display: "flex",
    mt: 0.25,
  },
  // Lista de ordens de serviço.
  listaOs: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 2,
    p: { xs: 1, sm: 2 },
    overflowY: "auto",
    maxHeight: { xs: "none", sm: "60vh", lg: "65vh" },
  },
  containerPaper: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    position: "relative",
    borderRadius: radius.panel,
    overflow: "hidden",
    // Sem isto o cartão herda flex-shrink: 1 do container da lista e é
    // comprimido; com o overflow: hidden acima, a compressão vira corte e o
    // fim do cartão (a descrição) some.
    flexShrink: 0,
    backgroundColor: theme.palette.background.wallpaper,
  },
  containerHeader: {
    display: "flex",
    flexDirection: "column",
    padding: 2,
    gap: 1,
  },
  chipSla: {
    color: theme.palette.white.main,
    fontWeight: "bold",
    borderRadius: "5px",
    height: "18px",
  },
  chipPriority: {
    color: theme.palette.white.main,
    fontWeight: "bold",
    height: "18px",
    borderRadius: "5px",
  },
  nameDescription: {
    fontWeight: "bold",
    fontSize: fonts.label,
    display: "flex",
    alignItems: "center",
    gap: 0.5,
  },
  boxDescription: {
    display: "flex",
    gap: 1,
  },
  valueDescription: {
    fontSize: fonts.label,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  containerDataDescription: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
  },
  containerPaperModal: {
    width: "100%",
    borderRadius: "16px",
    padding: 2,
    overflowY: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 1,
    flexWrap: "wrap",
  },
  boxBodyModal: { px: gutterX },
  containerBodyModal: { maxHeight: "65%", overflowY: "auto" },
  titleDescription: {
    fontSize: fonts.sectionTitle,
    fontWeight: "bold",

    display: "flex",
    alignItems: "center",
    gap: 0.5,
  },
  boxEdit: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: "50px",
    px: gutterX,
  },
  containerActions: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: 2,
    mr: 5,
    gap: 2,
  },
  containerData: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  containerDataTenico: {
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
    padding: 2,
  },
  titleData: { fontWeight: 600, fontSize: fonts.label },
  boxData: { display: "flex", flexDirection: "column", padding: 2 },
  boxHeader: { display: "flex", alignItems: "center", gap: 0.5 },
  boxDataTecnico: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    padding: 0.5,
  },
  containerStatusModal: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
  },
  containerMensagemOs: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
    backgroundColor: "transparent",
    p: 2,
    borderRadius: "16px",
    width: "100%",
  },
  titleChipModal: {
    fontWeight: "bold",
    fontSize: fonts.chip,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  chipStatus: {
    color: theme.palette.white.main,
    height: "18px",
    borderRadius: "5px",
    fontWeight: "bold",
    fontSize: fonts.chip,
  },
  boxImg: {
    width: "40px",
    height: "40px",
    objectFit: "cover",
    display: "block",
    borderRadius: "50%",
    overflow: "hidden",
    flexShrink: 0,
    flexGrow: 0,
  },
  boxWithoutImg: {
    width: "40px",
    height: "40px",

    display: "block",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.colors.black.medium
        : theme.palette.colors.black.lighter,
  },
  chip: {
    fontWeight: "bold",
    color: theme.palette.white.main,
    fontSize: fonts.chip,
    textTransform: "capitalize",
    maxWidth: "160px",
  },
  paperMensagem: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    borderRadius: "16px",
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.colors.black.dark
        : theme.palette.colors.black.light,
  },
  containerButton: {
    width: "100%",
    display: "flex",
    justifyContent: "left",
  },
  boxMensagem: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
  },
  containerBoxMensagem: {
    width: "100%",
    p: 2,
    display: "flex",
    alignItems: "center",
    gap: 2,
  },
  titleUser: {
    fontSize: fonts.sectionTitle,
    fontWeight: "bold",
  },
  titleDataMensagem: {
    fontSize: fonts.label,
  },
  avatar: { width: 30, height: 30 },
});

export default styles;
